import {
  css,
  FlattenInterpolation,
  FlattenSimpleInterpolation,
} from "styled-components";

import { Breakpoint, breakpoints, pxToEm } from "@otta/design-tokens";

interface From {
  from: Breakpoint | number;
}

interface To {
  to: Breakpoint | number;
}

type BreakpointOpts = From | To | (From & To);

const hasFrom = (opts: BreakpointOpts): opts is From =>
  typeof (opts as { from?: Breakpoint }).from !== "undefined";

const hasTo = (opts: BreakpointOpts): opts is To =>
  typeof (opts as { to?: Breakpoint }).to !== "undefined";

export const media = (
  opts: BreakpointOpts,
  type: "screen" | "all" | "print" = "screen"
) => {
  const queries: string[] = [type];

  if (hasFrom(opts)) {
    const value =
      typeof opts.from === "number" ? opts.from : breakpoints[opts.from];

    queries.push(`(min-width: ${pxToEm(value)})`);
  }

  if (hasTo(opts)) {
    const value = typeof opts.to === "number" ? opts.to : breakpoints[opts.to];

    queries.push(`(max-width: ${pxToEm(value - 1)})`);
  }

  const qs = queries.join(" and ");

  return <P extends object>(
    strings:
      | TemplateStringsArray // e.g. media({ from: "desktop" })`...`
      | FlattenSimpleInterpolation, // e.g. media({ from: "desktop" })(css`...`)
    ...interpolations: FlattenInterpolation<P>
  ) => {
    if ("raw" in strings) {
      return css`
        @media ${qs} {
          ${css(strings, ...interpolations)}
        }
      `;
    }

    return css`
      @media ${qs} {
        ${strings}
      }
    `;
  };
};
